import { Destination, SalesRecording } from '@marageti/z4-sdk/lib/travel';

export enum TripType {
  TripRequest = 'TripRequest',
  TripMatch = 'TripMatch',
}

type BaseBookingDetailsProps = {
  tripBudget: number;
  countries?: string[];
  departureDate: string,
  description: string;
  destinations?: Destination[];
  isLoading: boolean;
  numAdults: number;
  numChildren: number;
  partnerName?: string;
  returnDate: string,
  salesRecordings: SalesRecording[] | undefined;
  hideDetails: boolean;
};

export type BookingDetailsProps = | BaseBookingDetailsProps & {
  tripType: TripType.TripRequest;
} | BaseBookingDetailsProps & {
  tripType: TripType.TripMatch;
  partnerName: string;
};
